export const FETCH_TEASERBOXES = 'FETCH_TEASERBOXES'
export const FETCH_TEASERBOXES_PENDING = 'FETCH_TEASERBOXES_PENDING'
export const FETCH_TEASERBOXES_REJECTED = 'FETCH_TEASERBOXES_REJECTED'
export const FETCH_TEASERBOXES_FULFILLED = 'FETCH_TEASERBOXES_FULFILLED'
export const CLEAR_TEASERBOXES = 'CLEAR_TEASERBOXES'